import React from "react";
import _pubA97D53F3 from "./atoms.pc";
import _pub2F51C399 from "./breakpoints.pc";
import "./PageContent.pc.css";
function getDefault(module) {
  return module.default || module;
}

function castStyle(value) {
  var tov = typeof value;
  if (tov === "object" || tov !== "string" || !value) return value;
  return value.trim().split(";").reduce(function (obj, keyValue) {
    var kvp = keyValue.split(":");
    var key = kvp[0];
    var value = kvp[1];
    if (!value || value === "undefined") return obj;
    var trimmedValue = value.trim();
    if (trimmedValue === "undefined" || !trimmedValue) return obj;
    obj[key.trim()] = trimmedValue;
    return obj;
  }, {});
}

export const classNames = {

};

var $$Default = React.memo(React.forwardRef(function $$Default(props, ref) {
  return React.createElement("div", {
    "className": "_bcd195e8 _8d610c4 _pub-8d610c4 _pub-a97d53f3" + (props["class"] ? " " + props["class"] : "") + " " + " " + (props["className"] ? " " + props["className"] : "") + (props["spaceLeft"] ? " " + "_8d610c4_space-left _pub-8d610c4_space-left _pub-a97d53f3_space-left space-left" : "") + (props["center"] ? " " + "_8d610c4_center _pub-8d610c4_center _pub-a97d53f3_center center" : "") + (props["padded"] ? " " + "_8d610c4_padded _pub-8d610c4_padded _pub-a97d53f3_padded padded" : "") + (props["fixedWidth"] ? " " + "_8d610c4_fixed-width _pub-8d610c4_fixed-width _pub-a97d53f3_fixed-width fixed-width" : "") + (props["bottomSpace"] ? " " + "_8d610c4_bottom-space _pub-8d610c4_bottom-space _pub-a97d53f3_bottom-space bottom-space" : "") + (props["topSpace"] ? " " + "_8d610c4_top-space _pub-8d610c4_top-space _pub-a97d53f3_top-space top-space" : ""),
    "ref": ref,
    "data-testid": props["testId"],
  }, 
    React.createElement("div", {
      "className": "_26efead4 _8d610c4 _pub-8d610c4 _pub-a97d53f3",
    }, 
      props["children"]
    )
  )
}));
export default $$Default;


